import { MutationTree } from 'vuex';
import ILocalState from './stateInterface';

const mutations: MutationTree<ILocalState> = {
    setMyProjectsList(state, payload) {
        state.myProjectsList = payload;
    },
    setActiveProject(state, payload) {
        state.activeProject = payload;
    },
    setAllProjectItems(state, payload) {
        state.allProjectItems = payload;
    },
    setActiveSingleReport(state, payload) {
        state.activeSingleReport = payload;
    },
    setProjectOverview(state, payload) {
        state.projectOverview = payload;
    },
};

export default mutations;
